import { styled } from "@mui/material";
import Toolbar from "~/components/Toolbar";

interface CustomProps {
  noBorder?: boolean;
  /**
   * Top offset for sticky positioning. Use when StickyToolbar is nested
   * inside another sticky element (e.g., RouteTabs).
   * @default 0
   */
  topOffset?: number;
}

const StickyToolbar = styled(Toolbar, {
  shouldForwardProp: (prop) => prop !== "topOffset",
})<CustomProps>(({ theme, topOffset = 0 }) => {
  return {
    position: "sticky",
    top: topOffset,
    zIndex: theme.zIndex.appBar - 2,
    backdropFilter: "saturate(180%) blur(20px)",
    backgroundColor: "rgba(255, 255, 255, 0.7)",
  };
});

export default StickyToolbar;
